import React, { useState } from 'react'

import "./FormMin.css"


import Constants from '../../Constants'
import { useNavigate } from 'react-router-dom'
import { MzForm, MzFormCheckBox, MzFormInputText, MzSubmitButton } from '../../components/form'

import { Accordion, AccordionTab } from 'primereact/accordion'

import * as yup from 'yup'


import ApiUtils from "../../api/ApiUtils"

const label1 = "Dichiaro di aver preso visione dell’Informativa <a  target=”_blank” href=https://www.piutariffe.it/privacy-policy>Privacy</A> (obbligatorio) e di aver compreso le modalità con cui i miei dati personali verranno trattati.";
const label2 = "Comunicazioni promozionali<br> <div style='font-size:12px' >Acconsento al trattamento dei miei dati per l’invio di comunicazioni promozionali da parte di Datalia srl. con i seguenti mezzi (telefono con operatore, email), relative a prodotti e/o servizi di Datalia srl.</div>";
const label3 = "Cessione dati a terzi<br><div style='font-size:12px' > Acconsento di cedere i miei dati a terzi, partner del Titolare, per finalità di promozione commerciale secondo le modalità descritte all’ Art 2.3 dell’informativa privacy”. L’elenco delle terze parti a cui possono essere ceduti i dati è presente a questo link:  <a  target=”_blank” href=https://www.piutariffe.it/privacyterzi>Privacy terzi</a> Per migliorare la tua esperienza e offrirti promozioni personalizzate, Datalia S.r.l. potrebbe condividere i tuoi dati con società partner operanti in settori specifici. Puoi scegliere se autorizzare questa cessione e per quali categorie di soggetti. Acconsento alla cessione dei miei dati personali a società terze, partner di Datalia S.r.l., per ricevere offerte e promozioni commerciali relative ai seguenti settori:</div>";
const label4 = "Energia (fornitori di luce e gas)";
const label5 = "Telefonia e internet";
const label6 = "Servizi promozionali generali: Contact Center Energia";
const label7 = "Acconsento ad essere contattato telefonicamente";
const label8 = "Acconsento ad essere contattato via mail";

function FormMin({ answers, messages, setMessages }) {


    const formikRef = React.useRef()
    // const [checkbox0Checked, setCheckbox0Checked] = useState(false);
    const [checkbox1Checked, setCheckbox1Checked] = useState(false);
    const [checkbox2Checked, setCheckbox2Checked] = useState(false);
    const [checkbox3Checked, setCheckbox3Checked] = useState(false);
    const [checkbox4Checked, setCheckbox4Checked] = useState(false);
    const [checkbox5Checked, setCheckbox5Checked] = useState(false);
    const [checkbox6Checked, setCheckbox6Checked] = useState(false);
    const [checkbox7Checked, setCheckbox7Checked] = useState(false);
    const [checkbox8Checked, setCheckbox8Checked] = useState(false);

    const navigate = useNavigate()

    const [loading, setLoading] = React.useState(false)
    const [buttonDisabled, setButtonDisabled] = React.useState(false)


    let url = ''
    let resultsPage = ''

    if (answers.tipoRicerca == "fibra") {
        url = "tariff_comparator/v1/ans/c1/"
        resultsPage = '/results1'
    }

    if (answers.tipoRicerca == "luce") {
        url = "tariff_comparator/v1/ans/l/"
        resultsPage = '/resultsLuce'
    }

    if (answers.tipoRicerca == "gas") {
        url = "tariff_comparator/v1/ans/g/"
        resultsPage = '/resultsGas'
    }

    if (answers.tipoRicerca == "luce_gas") {
        url = "tariff_comparator/v1/ans/lg/"
        resultsPage = '/resultsLuceGas'
    }

    const initialValues = {
        nome: '',
        cellulare: '',
        email: '',
        //  consenso0: false,
        consenso1: false,
        consenso2: false,
        consenso3: false,
        consenso4: false,
        consenso5: false,
        consenso6: false,
        consenso7: false,
        consenso8: false,
    }





    const validationSchema = yup.object({

        nome: yup.string().required(Constants.validation.required),

        cellulare: yup.string()
            .required(Constants.validation.required)
            .phone_number(Constants.validation.invalid_phone)
            .nullable(),

        email: yup.string()
            .email("Email non valida")
            .required(Constants.validation.required)
        ,

        /* consenso0: yup.boolean()
             .oneOf([true], 'Devi accettare i termini e condizioni')
             .required(Constants.validation.required),*/
        consenso1: yup.boolean()
            .oneOf([true], Constants.validation.required)
            .required(Constants.validation.required),
        consenso2: yup.boolean()
        ,
        consenso3: yup.boolean(),


        consenso4: yup.boolean(),
        consenso5: yup.boolean(),
        consenso6: yup.boolean(),
        consenso7: yup.boolean(),
        consenso8: yup.boolean()



    })

    const onSubmit = async (data) => {

        const mergedAnswers = { ...answers, ...data }
        setLoading(true)

        const resp = await ApiUtils.post(url, mergedAnswers)

        if (resp.status == 200) {
            setLoading(false)
            setButtonDisabled(true)
            await window.Swal.fire({
                title: 'Tutto ok!',
                icon: 'success',
                confirmButtonText: 'Vai alle Offerte'

            })

            // console.log(resp.data)

            navigate(resultsPage, { state: { data: resp.data, answers: mergedAnswers } })



        }
    }

    const handleChangeCheckBox0 = (e) => {
        formikRef.current.setFieldValue("consenso0", e.checked);
        formikRef.current.setFieldValue("consenso1", e.checked);
        formikRef.current.setFieldValue("consenso2", e.checked);
        formikRef.current.setFieldValue("consenso3", e.checked);
        formikRef.current.setFieldValue("consenso4", e.checked);
        formikRef.current.setFieldValue("consenso5", e.checked);
        formikRef.current.setFieldValue("consenso6", e.checked);
        formikRef.current.setFieldValue("consenso7", e.checked);
        formikRef.current.setFieldValue("consenso8", e.checked);

    };

    const handleChangeCheckBox1 = (e) => {
        const checked = e.checked;
        setCheckbox1Checked(checked);

        /*  setCheckbox0Checked(checked && checkbox2Checked && checkbox3Checked);
      
          if (formikRef.current) {
              formikRef.current.setFieldValue("consenso1", checked);
              formikRef.current.setFieldValue("consenso0", checked && checkbox2Checked && checkbox3Checked);
          }*/
    };

    const handleChangeCheckBox2 = (e) => {
        const checked = e.checked;
        setCheckbox2Checked(checked);

        /* setCheckbox0Checked(checkbox1Checked && checked && checkbox3Checked);
     
         if (formikRef.current) {
             formikRef.current.setFieldValue("consenso2", checked);
             formikRef.current.setFieldValue("consenso0", checkbox1Checked && checked && checkbox3Checked);
         }*/
    };

    const handleChangeCheckBox3 = (e) => {
        const checked = e.checked;
        setCheckbox3Checked(checked);

        /* setCheckbox0Checked(checkbox1Checked && checkbox2Checked && checked);
     
         if (formikRef.current) {
             formikRef.current.setFieldValue("consenso3", checked);
             formikRef.current.setFieldValue("consenso0", checkbox1Checked && checkbox2Checked && checked);
         }*/
    };

    const handleChangeCheckBox4 = (e) => {
        const checked = e.checked;
        setCheckbox4Checked(checked);

        /*     if (formikRef.current) {
                 formikRef.current.setFieldValue("consenso4", checked);
             }*/
    };

    const handleChangeCheckBox5 = (e) => {
        const checked = e.checked;
        setCheckbox5Checked(checked);

        /*  if (formikRef.current) {
              formikRef.current.setFieldValue("consenso5", checked);
          }*/
    };

    const handleChangeCheckBox6 = (e) => {
        const checked = e.checked;
        setCheckbox6Checked(checked);

        /* if (formikRef.current) {
             formikRef.current.setFieldValue("consenso6", checked);
         }*/
    };

    const handleChangeCheckBox7 = (e) => {
        const checked = e.checked;
        setCheckbox7Checked(checked);
    };

    const handleChangeCheckBox8 = (e) => {
        const checked = e.checked;
        setCheckbox8Checked(checked);
    };




    return (
        <div className='ml-2 flex flex-column justify-content-center align-items-center  '>

            <MzForm initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit} innerRef={formikRef}>
                <MzFormInputText name="nome" label={Constants.labels.name_surname} isTouched="true" />
                <MzFormInputText name="cellulare" label="Telefono cellulare" />
                <MzFormInputText name="email" label="Email" />


                <div className="field w-full">
                    <MzFormCheckBox name="consenso1" checked={checkbox1Checked} label={label1} onChange={handleChangeCheckBox1}></MzFormCheckBox>
                    <MzFormCheckBox name="consenso2" checked={checkbox2Checked} label={label2} onChange={handleChangeCheckBox2}></MzFormCheckBox>
                    <MzFormCheckBox name="consenso3" checked={checkbox3Checked} label={label3} onChange={handleChangeCheckBox3}></MzFormCheckBox>

                    <MzFormCheckBox name="consenso4" checked={checkbox4Checked} label={label4} onChange={handleChangeCheckBox4}></MzFormCheckBox>
                    <MzFormCheckBox name="consenso5" checked={checkbox5Checked} label={label5} onChange={handleChangeCheckBox5}></MzFormCheckBox>
                    <MzFormCheckBox name="consenso6" checked={checkbox6Checked} label={label6} onChange={handleChangeCheckBox6}></MzFormCheckBox>

                    <MzFormCheckBox name="consenso7" checked={checkbox6Checked} label={label7} onChange={handleChangeCheckBox7}></MzFormCheckBox>
                    <MzFormCheckBox name="consenso8" checked={checkbox6Checked} label={label8} onChange={handleChangeCheckBox8}></MzFormCheckBox>


                </div>

                <MzSubmitButton loading={loading} disabled={buttonDisabled} label="Confronta le offerte"></MzSubmitButton>



            </MzForm>






        </div>
    )
}



export default FormMin